import {
    type BannerReserveTypeEnum,
    type Banner,
    type BannerDisplaySizeEnum,
    type BannerPositionEnum,
    type BannerPrivacyEnum,
    type BannerSearchResultEnum,
} from '@clients/ContentApi';
import { toAbsoluteSrc } from '@store/content';

export default class SiteBanner {
    constructor(data: Banner) {
        this.id = data.id;
        this.privacy = data.privacy;
        this.whiteLabel = data.whiteLabel;
        this.displaySize = data.displaySize;
        this.position = data.position;
        this.desktopImageUrl =
            toAbsoluteSrc(data.desktopImage?.url) || undefined;
        this.desktopBlurhash = data.desktopImage?.blurhash;
        this.desktopWidth = data.desktopImage?.width;
        this.desktopHeight = data.desktopImage?.height;
        this.mobileImageUrl = toAbsoluteSrc(data.image?.url) || undefined;
        this.mobileBlurhash = data.image?.blurhash;
        this.mobileWidth = data.image?.width;
        this.mobileHeight = data.image?.height;
        this.link = data.link;
        this.urlPattern = data.urlPattern;
        this.international = data.international;
        this.title = data.title;
        this.reserveType = data.reserveType;
        this.searchResult = data.searchResult;
    }

    id: string;
    privacy?: BannerPrivacyEnum;
    whiteLabel?: string | undefined;
    displaySize?: BannerDisplaySizeEnum;
    position?: BannerPositionEnum;
    desktopImageUrl?: string;
    desktopBlurhash?: string;
    desktopWidth?: number;
    desktopHeight?: number;
    mobileImageUrl?: string;
    mobileBlurhash?: string;
    mobileWidth?: number;
    mobileHeight?: number;
    link?: string;
    urlPattern?: string;
    international?: boolean;
    title?: string;
    reserveType?: BannerReserveTypeEnum;
    searchResult?: BannerSearchResultEnum;

    toJSON() {
        return { ...this };
    }
}
